module.exports = __webpack_public_path__ + "img/icon_zhekou.7cecc669.svg";